;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { PBSTimezones } from '@/lib/types/api/timezones';

export enum ListingPositionEnum {
  notInSchedule = 'notInSchedule',
  startsBeforeScheduleStartButNotEnded = 'startsBeforeScheduleStartButNotEnded',
  startsAtScheduleStart = 'startsAtScheduleStart',
  startsAtScheduleStartAndIsEnded = 'startsAtScheduleStartAndIsEnded',
  startsBeforeScheduleStartAndEnded = 'startsBeforeScheduleStartAndEnded',
  startsAfterScheduleEnd = 'startsAfterScheduleEnd',
  duringSchedule = 'duringSchedule',
  duringScheduleEndsAfterScheduleEnd = 'duringScheduleEndsAfterScheduleEnd',
  // admittedly, these are edge cases, but they're possible
  startsBeforeScheduleStartEndsAtScheduleEnd = 'startsBeforeScheduleStartEndsAtScheduleEnd',
  startsAtScheduleStartEndsAfterScheduleEnd = 'startsAtScheduleStartEndsAfterScheduleEnd',
  listingSameAsSchedule = 'listingSameAsSchedule',
  listingLongerThanSchedule = 'listingLongerThanSchedule',
}

export interface Channel {
  profile: string;
  feed_cid: string;
  digital_channel: string;
  analog_channel: string;
  short_name: string;
  full_name: string;
  timezone: PBSTimezones;
  feed_image: {
    white_logo?: string;
    color_logo?: string;
  };
  listings: Listing[];
  item_type: string;
}

export interface Listing {
  start_time: Date;
  duration: number;
  show_title: string;
  show_tms_id?: string;
  show_description?: string;
  episode_title: string;
  episode_description: string;
  tvss_episode_id: string;
  tvss_show_id: string;
  episode_schedule_url: string;
  episode_tms_id: string;
  show_schedule_url: string;
  listing_image: string | null;
  item_type: string;
  listing_position?: ListingPositionEnum;
}

export type Theme = 'light' | 'dark';
